let el;
let text;
let knopf;
let timer;

/**
 * Kurze Meldung. Mit `aktion` trägt sie einen Knopf - für Rückgängig, das die
 * Rückfrage ersetzt: ein Löschen soll schnell gehen und trotzdem nicht endgültig
 * sein, und ein Dialog bremst auch dort, wo gar nichts schiefging.
 */
export function toast(message, optionen = 2200) {
  const { ms = 2200, aktion = null, beiAktion = null } =
    typeof optionen === 'number' ? { ms: optionen } : optionen;
  if (!el) {
    el = document.createElement('div');
    el.className = 'toast';
    el.setAttribute('role', 'status');
    text = document.createElement('span');
    knopf = document.createElement('button');
    knopf.type = 'button';
    knopf.className = 'toast__aktion';
    el.append(text, knopf);
    document.body.append(el);
  }
  text.textContent = message;
  knopf.hidden = !aktion;
  knopf.textContent = aktion || '';
  knopf.onclick = aktion
    ? () => { clearTimeout(timer); el.classList.remove('is-on'); beiAktion?.(); }
    : null;
  requestAnimationFrame(() => el.classList.add('is-on'));
  clearTimeout(timer);
  timer = setTimeout(() => el.classList.remove('is-on'), aktion ? Math.max(ms, 6000) : ms);
}
